if (!customElements.get('reviews-slider')) {
  customElements.define(
    'reviews-slider',
    class SliderComponent extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.btnNext = this.querySelector('.reviews__btn[name="next"]');
        this.btnPrev = this.querySelector('.reviews__btn[name="prev"]');
        this.sliderWrapper = this.querySelector('.reviews__list-wrapper');
        this.slider = this.querySelector(`#Slider-${this.dataset.sectionId}`);
        this.secondSlide = this.querySelector(`#Slider-${this.dataset.sectionId} > .reviews__list-item + .reviews__list-item`);

        this.desktopColumns = parseInt(this.dataset.desktopColumns);
        this.tabletColumns = parseInt(this.dataset.tabletColumns);
        this.mobileColumns = parseInt(this.dataset.mobileColumns);
        this.slideCount = parseInt(this.dataset.slideCount);

        this.currentSlide = 0;

        this.currentColumns = this.mobileColumns;

        this.mobileQuery = matchMedia('screen and (max-width: 767px)');
        if (this.mobileQuery.matches) this.currentColumns = this.mobileColumns;
        this.mobileQueryHandler = (e) => {
          if (e.matches) this.currentColumns = this.mobileColumns;
        }
        this.mobileQuery.addEventListener('change', this.mobileQueryHandler)

        this.tabletQuery = matchMedia('screen and (min-width: 768px) and (max-width: 1023px)');
        if (this.tabletQuery.matches) this.currentColumns = this.tabletColumns;
        this.tabletQueryHandler = (e) => {
          if (e.matches) this.currentColumns = this.tabletColumns;
        }
        this.tabletQuery.addEventListener('change', this.tabletQueryHandler)

        this.desktopQuery = matchMedia('screen and (min-width: 1024px)');
        if (this.desktopQuery.matches) this.currentColumns = this.desktopColumns;
        this.desktopQueryHandler = (e) => {
          if (e.matches) this.currentColumns = this.desktopColumns;
        }
        this.desktopQuery.addEventListener('change', this.desktopQueryHandler)

        this.btnNextHandler = this.btnHandler.bind(this, 1);
        this.btnPrevHandler = this.btnHandler.bind(this, -1);
        this.btnNext.addEventListener('click', this.btnNextHandler);
        this.btnPrev.addEventListener('click', this.btnPrevHandler);

        this.resizeHandler = this.updateScroll.bind(this);
        window.addEventListener('resize', this.resizeHandler);
      }

      disconnectedCallback() {
        this.btnNext.removeEventListener('click', this.btnNextHandler);
        this.btnPrev.removeEventListener('click', this.btnPrevHandler);

        this.mobileQuery.removeEventListener('change', this.mobileQueryHandler)
        this.tabletQuery.removeEventListener('change', this.tabletQueryHandler)
        this.desktopQuery.removeEventListener('change', this.desktopQueryHandler)

        window.removeEventListener('resize', this.resizeHandler);
      }

      btnHandler(offset) {
        this.currentSlide += offset;
        this.currentSlide %= this.slideCount - this.currentColumns + 1;
        if (this.currentSlide < 0) this.currentSlide += this.slideCount - this.currentColumns + 1;

        this.updateScroll();
      }

      updateScroll() {
        this.currentSlide %= this.slideCount - this.currentColumns + 1;

        this.sliderWrapper.scrollTo({
          left: this.currentSlide * (this.secondSlide.offsetLeft - this.sliderWrapper.offsetLeft),
          behavior: 'smooth',
        });
      }
    }
  )
}
